import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";
import { cardStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cardStyles.container = {
    css: css`
        padding: 0;
        > ${GridOffset} {
            border: 1px solid ${getColor("common.border")};
            margin: 0px;
            width: 100%;
        }
    `,
};
cardStyles.imageItem = {
    width: [12, 12, 2, 2, 2],
    printWidth: 2,
    css: css`
        @media print {
            max-height: 200px;
            max-width: 200px;
            display: none !important;
        }
        background: #f3f3f3;
    `,
};
cardStyles.productNameItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

cardStyles.productNameLink = {
    css: css`
        font-size: 20px;
        font-family:"Roboto-Bold"
        line-height: 1;
        margin-bottom: 5px;
        @media print {
            font-size: 16px !important;
        }
    `,
};
cardStyles.mgfGridContainer = {
    css: css`
        padding: 4px;
        > ${GridOffset} {
            width: 100%;
        }
    `,
};
cardStyles.mgfItem = {
    width: [12, 12, 12, 12, 12],
    printWidth: 12,
    css: css`
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
        @media print {
            > div {
                display: flex;
                flex-direction: row;
                width: 100%;
            }
            max-width: 100% !important;
            width: 100% !important;
            flex-basis: 100% !important;
        }
    `,
};
cardStyles.myPartItem = {
    width: [12, 6, 6, 6, 4],
    printWidth: 12,
    css: css`
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
        @media print {
            > div {
                display: flex;
                flex-direction: row;
                width: 100%;
            }
            max-width: 100% !important;
            width: 100% !important;
            flex-basis: 100% !important;
        }
    `,
};
cardStyles.partItem = {
    width: [12, 6, 6, 6, 5],
    printWidth: 12,
    css: css`
        > div {
            display: flex;
            flex-direction: row;
            width: 100%;
        }
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
        @media print {
            > div {
                display: flex;
                flex-direction: row;
                width: 100%;
            }
            max-width: 100% !important;
            width: 100% !important;
            flex-basis: 100% !important;
        }
    `,
};
cardStyles.notesItem = {
    width: 12,
    css: css`
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
    `,
};
cardStyles.infoItem = {
    width: [12, 12, 10, 10, 10],
    printWidth: 12,
};
cardStyles.infoLeftColumn = {
    width: [12, 12, 9, 7, 6],
    printWidth: 6,
};
cardStyles.infoRightColumn = {
    width: [12, 12, 3, 5, 6],
    printWidth: 6,
    css: css`
        display: flex;
        align-items: center;
        @media print {
            height: 100%;
            align-items: flex-end;
            > div {
                margin-top: auto;
            }
        }
    `,
};
cardStyles.priceItem = {
    width: [6, 6, 12, 12, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;
        > div {
            flex-direction: column;
        }
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
        p:last-child {
            color: ${getColor("primary")};
        }
    `,
};

cardStyles.qtyItem = {
    width: [6, 6, 12, 12, 4],
    printWidth: 4,
    css: css`
        > div {
            flex-direction: column;
        }
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
        p:last-child {
            color: ${getColor("primary")};
            font-family:"Roboto-Bold"
        }
    `,
};

cardStyles.totalItem = {
    width: [12, 12, 12, 12, 4],
    printWidth: 4,
    css: css`
        font-weight: 600;
        flex-direction: column;
        > div {
            flex-direction: column;
        }
        p:first-child {
            margin-right: 3px;
            color: ${getColor("text.main")};
        }
        p:nth-child(2) {
            color: ${getColor("primary")};
        }
    `,
};

cardStyles.partStyles = {
    wrapper: {
        css: css`
            @media print {
                display: flex;
                flex-direction: row !important;
            }
        `,
    },
};
